import React, { useCallback, useContext } from 'react';
import { IStyleContext, StyleContext } from '../styleState/styleContext';
import { useGoBack } from 'hooks/useGoBack';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirmNew } from 'components/ModalWindows/ModalToConfirmNew';
import { ModalSentSuccessfullyNew } from 'components/ModalWindows/ModalSentSuccessfullyNew';
import { ModalSentErrorNew } from 'components/ModalWindows/ModalSentErrorNew';

export const ModalWindows: React.FC = () => {
	const { submit, changeTypeOfModalWindow, refetchData, typeOfModalWindow } = useContext<IStyleContext>(StyleContext);
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/clients/customers-new-ui');
	}, [goBack]);

	const handleConfirm = useCallback(() => submit(), [submit]);

	const handleUpdateData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, [refetchData, changeTypeOfModalWindow]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirmNew
					onConsentEvent={handleRedirect}
					onFailureEvent={handleCloseModal}
					description="cancelSaveInfo"
					typeOfInfoIcon="toSave"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirmNew
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					description="saveInfo"
					typeOfInfoIcon="toSave"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfullyNew onConsentEvent={handleUpdateData} description="savedSuccessfully" />
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="errorWhileSaving" />
			)}
			{typeOfModalWindow === 'pdfFileSizeExceeded' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="fileSizeExceeded"
					translationOptions={{ size: '25MB' }}
				/>
			)}
			{typeOfModalWindow === 'PDFMenuSizeExceeded' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="fileSizeExceeded"
					translationOptions={{ size: '20MB' }}
				/>
			)}
			{typeOfModalWindow === 'invalidPdfFileFormat' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="invalidFileFormat"
					translationOptions={{ format: '.pdf' }}
				/>
			)}
			{typeOfModalWindow === 'fileUploadError' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="fileUploadError" />
			)}
			{typeOfModalWindow === 'fileDownloadError' && (
				<ModalSentErrorNew onConsentEvent={handleCloseModal} description="fileDownloadError" />
			)}
			{typeOfModalWindow === 'invalidFileFormat' && (
				<ModalSentErrorNew
					onConsentEvent={handleCloseModal}
					description="invalidFileFormatPhoto"
					translationOptions={{ formats: '.jpeg, .jpg, .png' }}
				/>
			)}
		</ModalWrapper>
	);
};
